import type { InventoryItem } from '../types/inventory.types';
import { InventoryService } from '../services';

interface UseInventoryImageUpdateProps {
  companyId: string | null;
  showSnackbar: (message: string, type: 'success' | 'error' | 'warning' | 'info') => void;
  setError: (error: string | null) => void;
  setInventoryItems: React.Dispatch<React.SetStateAction<InventoryItem[]>>;
  handleRefreshInventory: () => Promise<void>;
}

export const useInventoryImageUpdate = ({
  companyId,
  showSnackbar,
  setError,
  setInventoryItems,
  handleRefreshInventory,
}: UseInventoryImageUpdateProps) => {
  
  const saveImages = async (selectedImageItem: InventoryItem, selectedUrls: string[]) => {
    if (!selectedImageItem || !companyId) return;

    const { id } = selectedImageItem;
    const imageUrlString = selectedUrls.length > 0 ? selectedUrls.join(',') : null;
    
    try {
        console.log(`🖼️ [SAVE IMAGES] Resim güncelleniyor: ${id}`, { imageUrlString });
        
        // ✅ SQL API kullanarak resim güncelle
        // Sadece imageUrl alanını güncellemek için mevcut ürün bilgilerini gönderiyoruz
        const updateDto: any = {
          id: selectedImageItem.id,
          companyId: companyId,
          stockCode: selectedImageItem.stockCode,
          name: selectedImageItem.name,
          categoryId: selectedImageItem.categoryId || null,
          brandId: selectedImageItem.brandId || null,
          branchesId: selectedImageItem.branchesId || null,
          purchasePrice: selectedImageItem.purchasePrice || 0,
          purchaseCurrency: selectedImageItem.purchaseCurrency || 'TRY',
          purchaseVendor: (selectedImageItem as any).purchaseVendor || null,
          purchasePrice2: (selectedImageItem as any).purchasePrice2 || null,
          purchaseCurrency2: (selectedImageItem as any).purchaseCurrency2 || null,
          purchaseVendor2: (selectedImageItem as any).purchaseVendor2 || null,
          purchasePrice3: (selectedImageItem as any).purchasePrice3 || null,
          purchaseCurrency3: (selectedImageItem as any).purchaseCurrency3 || null,
          purchaseVendor3: (selectedImageItem as any).purchaseVendor3 || null,
          salePrice: selectedImageItem.salePrice,
          saleCurrency: selectedImageItem.saleCurrency || 'TRY',
          saleCustomer: (selectedImageItem as any).saleCustomer || null,
          salePrice2: (selectedImageItem as any).salePrice2 || null,
          saleCurrency2: (selectedImageItem as any).saleCurrency2 || null,
          saleCustomer2: (selectedImageItem as any).saleCustomer2 || null,
          salePrice3: (selectedImageItem as any).salePrice3 || null,
          saleCurrency3: (selectedImageItem as any).saleCurrency3 || null,
          saleCustomer3: (selectedImageItem as any).saleCustomer3 || null,
          listPrice: (selectedImageItem as any).listPrice || null,
          listCurrency: (selectedImageItem as any).listCurrency || null,
          unit: selectedImageItem.unit,
          canBeNegative: (selectedImageItem as any).canBeNegative ?? true,
          minStockLevel: (selectedImageItem as any).minStockLevel || null,
          maxStockLevel: (selectedImageItem as any).maxStockLevel || null,
          description: selectedImageItem.description || '',
          barcode: selectedImageItem.barcode || '',
          vatRate: selectedImageItem.vatRate,
          vatStatus: selectedImageItem.vatStatus,
          sctRate: (selectedImageItem as any).sctRate || null,
          sctStatus: (selectedImageItem as any).sctStatus || null,
          imageUrl: imageUrlString,
          imageUrls: selectedUrls.length > 0 ? selectedUrls : [],
          variants: (selectedImageItem as any).variants || null,
          printerGroup: (selectedImageItem as any).printerGroup || null,
          departmentNo: (selectedImageItem as any).departmentNo || null,
          isActive: selectedImageItem.isActive
        };
        
        // SQL API ile güncelle
        await InventoryService.updateItem(companyId, id, updateDto);
        
        console.log(`✅ [SAVE IMAGES] Ürün ${id} için resimler SQL'de güncellendi.`);
        
        // State'i de anında güncelleyelim
        setInventoryItems(prevItems =>
            prevItems.map(item =>
                item.id === id ? { ...item, imageUrl: imageUrlString } : item
            )
        );
        
        showSnackbar('Ürün resimleri başarıyla güncellendi!', 'success');
        
        // Arka planda liste yenileme
        setTimeout(() => {
          handleRefreshInventory();
        }, 1000);
        
    } catch (error) {
        console.error("❌ [SAVE IMAGES] Resim URL'leri güncellenirken hata oluştu:", error);
        setError("Resimleri güncellerken bir hata oluştu.");
        showSnackbar('Resimleri güncellerken bir hata oluştu', 'error');
    }
  };

  return {
    saveImages,
  };
};

